import React from 'react';
import { IconLookup } from '@fortawesome/fontawesome-common-types';
import { Heading, Icon } from '@innovationnorway/cl-react';
type Props = {
  children: React.ReactNode;
  header: string;
  faIcon?: string;
  iconDef?: IconLookup;
};
const IconParagraph = ({ children, header, faIcon, iconDef }: Props) => {
  return (
    <>
      <div className="display--flex align-items--center gap--2">
        {faIcon && <Icon prefix="fasr" iconName={faIcon.split(' ').pop()?.replace(/^fa-/, '') ?? ''} />}
        {iconDef && (
          <Icon prefix={iconDef.prefix === 'fas' ? 'fass' : 'fasr'} iconName={iconDef.iconName as string} />
        )}
        <Heading level={3} data-size="xl" className="margin-bottom--0 font-size--x-large">
          {header}
        </Heading>
      </div>
      {children}
    </>
  );
};
export default IconParagraph;
